import { Image, ChevronDown } from 'lucide-react';
import { FormData } from '../../types';
import { logoExampleOptions } from '../../constants';
import { useState } from 'react';

interface LogoExamplesProps {
  formData: FormData;
  handleCheckboxChange: (field: keyof FormData, value: string) => void;
  showErrors: boolean;
}

export const LogoExamples = ({ formData, handleCheckboxChange, showErrors }: LogoExamplesProps) => {
  const [visibleLogos, setVisibleLogos] = useState(12);

  const loadMoreLogos = () => {
    setVisibleLogos(prev => Math.min(prev + 12, logoExampleOptions.length));
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl sm:text-2xl font-semibold flex items-center gap-3 text-blue-900">
        <Image className="text-[#6366F1]" />
        Logo Examples
      </h2>
      <div className="space-y-2">
        <p className="text-gray-600">
          Select at least one logo that inspires you <span className="text-red-500">*</span>
        </p>
        <div className="text-sm text-gray-500">
          Selected: {formData.logoExamples.length}/5
          {showErrors && formData.logoExamples.length === 0 && (
            <p className="mt-1 text-sm text-red-600">Please select at least one logo example</p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
        {logoExampleOptions.slice(0, visibleLogos).map(logo => (
          <div
            key={logo.id}
            onClick={() => handleCheckboxChange('logoExamples', logo.id.toString())}
            className={`aspect-square rounded-lg overflow-hidden cursor-pointer transition-all duration-300 relative group ${
              formData.logoExamples.includes(logo.id.toString())
                ? 'ring-2 ring-[#6366F1] shadow-lg shadow-indigo-100'
                : 'hover:shadow-lg hover:shadow-indigo-50 ring-1 ring-gray-100'
            }`}
          >
            <img
              src={logo.image}
              alt={`Logo example ${logo.id}`}
              className="w-full h-full object-cover"
            />
            <div 
              className={`absolute inset-0 transition-opacity duration-300 ${
                formData.logoExamples.includes(logo.id.toString())
                  ? 'opacity-100'
                  : 'opacity-0 group-hover:opacity-100'
              }`}
              style={{
                background: 'linear-gradient(180deg, rgba(99, 102, 241, 0.1) 0%, rgba(99, 102, 241, 0) 100%)'
              }}
            />
          </div>
        ))}
      </div>
      {visibleLogos < logoExampleOptions.length && (
        <div className="mt-8 text-center">
          <button
            onClick={loadMoreLogos}
            className="flex items-center gap-2 px-6 py-3 mx-auto text-[#6366F1] font-medium hover:bg-[#F5F3FF] rounded-full transition-colors"
          >
            View More
            <ChevronDown size={20} />
          </button>
        </div>
      )}
    </div>
  );
};